import { render, staticRenderFns } from "./PillBadgeLight.vue?vue&type=template&id=c81f5848&"
import script from "./PillBadgeLight.vue?vue&type=script&lang=js&"
export * from "./PillBadgeLight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports